import React from "react";
import { Card, Container } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import QuoteListing from "./QuoteListing";

const Quotes = () => {
  const breadcrumbItems = [
    { title: "Order", link: "" },
    { title: "Quotes", link: "/order/quotes" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <QuoteListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Quotes;
